var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button-group',_vm._l((_vm.buttonList),function(item){return _c('el-button',{key:item.id,attrs:{"type":item.type,"size":item.size,"icon":item.icon},on:{"click":function($event){return _vm.click(item.event)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }